import { render, staticRenderFns } from "./SetupMfaModal.vue?vue&type=template&id=3bc1361a&scoped=true&"
import script from "./SetupMfaModal.vue?vue&type=script&lang=js&"
export * from "./SetupMfaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc1361a",
  null
  
)

export default component.exports